import { z } from "zod";

// see https://docs.aws.amazon.com/location/latest/developerguide/category-filtering.html
export const FilterCategory = z.enum(["AddressType"]);
export type FilterCategory = z.infer<typeof FilterCategory>;

export const AddressSearchRequest = z.object({
  Text: z.string(),
  MaxResults: z.number(),
  FilterCountries: z.array(z.string()).nullish(),
  FilterCategories: z.array(FilterCategory).nullish(),
});
export type AddressSearchRequest = z.infer<typeof AddressSearchRequest>;

export const SearchSuggestion = z.object({
  Text: z.string(),
  PlaceId: z.string(),
});
export type SearchSuggesetion = z.infer<typeof SearchSuggestion>;

export const SearchSuggestionResponse = z.object({
  Summary: z.object({
    Text: z.string(),
    MaxResults: z.number(),
    DataSource: z.string(),
  }),
  Results: z.array(SearchSuggestion),
});

export type SearchSuggestionResponse = z.infer<typeof SearchSuggestionResponse>;

export const Place = z.object({
  Label: z.string(),
  Geometry: z.object({ Point: z.array(z.number()) }),
  AddressNumber: z.string(),
  Street: z.string(),
  Municipality: z.string(),
  Region: z.string(),
  Neighborhood: z.string().optional(),
  SubRegion: z.string().optional(),
  Country: z.string(),
  PostalCode: z.string(),
  Interpolated: z.boolean(),
  Categories: z.array(z.string()),
  SubMunicipality: z.string().optional(),
});
export type Place = z.infer<typeof Place>;

export const GetPlaceResponse = z.object({ Place });
export type GetPlaceResponse = z.infer<typeof GetPlaceResponse>;
